function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Form, Button, Input, Alert } from "antd";
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Common from "../includes/Common";
import { Link } from 'react-router-dom';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var UserLogin = function UserLogin() {
  var navigate = useNavigate();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    formLoading = _useState2[0],
    setFormLoading = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormError = _useState4[0],
    setIsFormError = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    errorMessage = _useState6[0],
    setErrorMessage = _useState6[1];
  var onFinish = function onFinish(values) {
    setFormLoading(true);
    setIsFormError(false);
    var formData = new FormData();
    formData.append('mobile', values.mobile);
    formData.append('password', values.password);
    axios.post(Common.baseApiUrl + 'login', formData).then(function (result) {
      setFormLoading(false);
      var data = result['data'];
      if (data['status'] == 200) {
        var usr = data['user'];
        localStorage.removeItem('userData');
        localStorage.setItem('userData', JSON.stringify(usr));
        localStorage.setItem('isOn', true);
        location.reload();
        //navigate('/bonjour'); 
      } else {
        setErrorMessage(data['message']);
        setIsFormError(true);
      }
    });
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        fontSize: '17px',
        padding: '10px 0px'
      },
      children: ["Bienvenue sur ", /*#__PURE__*/_jsx("b", {
        children: "Naatou"
      }), ", veuillez entrer vos identifiant pour acceder \xE0 votre compte"]
    }), isFormError ? /*#__PURE__*/_jsx(Alert, {
      style: {
        marging: '5px 0px',
        fontSize: '14px'
      },
      message: errorMessage,
      type: "error",
      showIcon: true
    }) : /*#__PURE__*/_jsx("span", {}), /*#__PURE__*/_jsxs(Form, {
      name: "ulogin",
      layout: "vertical",
      initialValues: {
        remember: true
      },
      onFinish: onFinish,
      autoComplete: "off",
      children: [/*#__PURE__*/_jsx(Form.Item, {
        label: "Num\xE9ro mobile",
        name: "mobile",
        rules: [{
          required: true,
          message: 'Veuillez entrer un numéro de téléphone'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Mot de passe",
        name: "password",
        rules: [{
          required: true,
          message: 'Le mot de passe est obligatoire !'
        }],
        children: /*#__PURE__*/_jsx(Input.Password, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "primary",
          loading: formLoading,
          size: "middle",
          htmlType: "submit",
          children: /*#__PURE__*/_jsx("b", {
            children: "SE CONNECTER"
          })
        })
      })]
    })]
  });
};
export default UserLogin;